import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import JsonData from "../../data/data.json";
import { navigateToSection } from "../../utils/hashSectionNav";
import { MalluLockup } from "./malluMark";
import { scrollToMalluSection } from "./MalluNav";
import "./mallu.css";

/**
 * Rodapé do design adaptado às rotas reais do template
 * (conta, para você / empresa, contratos, políticas, ouvidoria, cancelamento).
 */
export const MalluFooter = () => {
  const { t } = useTranslation("malluLanding");
  const { t: tCommon } = useTranslation("common");
  const navigate = useNavigate();
  const location = useLocation();
  const contact = JsonData.Contact || {};
  const line1 = contact.line1 || {};
  const year = new Date().getFullYear();

  const goTo = (id) => {
    if (location.pathname === "/") scrollToMalluSection(id);
    else navigateToSection(navigate, location, id);
  };

  const sectionLink = (id, label) => (
    <a
      key={id}
      href={`/#${id}`}
      onClick={(e) => {
        e.preventDefault();
        goTo(id);
      }}
    >
      {label}
    </a>
  );

  const addressLine = [line1.address, line1.complemento, line1.bairro, line1.city]
    .filter(Boolean)
    .join(", ");

  return (
    <footer className="pp-footer">
      <div className="pp-footer-inner">
        <div className="pp-footer-grid">
          <div className="pp-footer-brand">
            <MalluLockup />
            <div className="pp-footer-tag">{t("footer.tagline")}</div>
          </div>

          <div className="pp-footer-col">
            <h3>{t("footer.product")}</h3>
            <Link to="/account">{t("footer.links.digitalAccount")}</Link>
            {sectionLink("cartao", t("footer.links.card"))}
            {sectionLink("pix", t("footer.links.pix"))}
            <Link to="/foru">{tCommon("footer.productLinks.title3")}</Link>
            <Link to="/forujob">{tCommon("footer.productLinks.title2")}</Link>
          </div>

          <div className="pp-footer-col">
            <h3>{t("footer.institutional")}</h3>
            {sectionLink("inicio", t("footer.links.about"))}
            <Link to="/workforus">{tCommon("footer.aboutLinks.title2")}</Link>
            <Link to="/message">{tCommon("footer.aboutLinks.title3")}</Link>
            <Link to="/contratoPF">{tCommon("footer.productLinks.title4")}</Link>
            <Link to="/contratoPJ">{tCommon("footer.productLinks.title5")}</Link>
            <Link to="/garantias">{tCommon("footer.productLinks.title6")}</Link>
          </div>

          <div className="pp-footer-col">
            <h3>{t("footer.help")}</h3>
            {sectionLink("faq", t("footer.links.helpCenter"))}
            {sectionLink("seguranca", t("footer.links.security"))}
            <Link to="/ouvidoria">{tCommon("footer.lgpdLinks.title4")}</Link>
            <Link to="/cancelamento-de-conta">{tCommon("footer.lgpdLinks.title5")}</Link>
          </div>

          <div className="pp-footer-col">
            <h3>{t("footer.legal")}</h3>
            <Link to="/ciber-security">{tCommon("footer.lgpdLinks.title1")}</Link>
            <Link to="/dados-security">{tCommon("footer.lgpdLinks.title2")}</Link>
            <Link to="/uses-security">{tCommon("footer.lgpdLinks.title3")}</Link>
          </div>
        </div>

        <address className="pp-footer-company">
          {contact.nameBank2 ? <strong>{contact.nameBank2}</strong> : null}
          {line1.cnpj ? (
            <span>
              {line1.razaoSocial ? `${line1.razaoSocial} · ` : ""}
              {tCommon("footer.cnpjPrefix")} {line1.cnpj}
            </span>
          ) : null}
          {addressLine ? (
            <span>
              {addressLine}
              {line1.cep ? ` · ${tCommon("footer.cepPrefix")} ${line1.cep}` : ""}
            </span>
          ) : null}
          {contact.email ? <a href={`mailto:${contact.email}`}>{contact.email}</a> : null}
          {contact.phone ? (
            <a href={`tel:+55${contact.phone.replace(/\D/g, "")}`}>{contact.phone}</a>
          ) : null}
        </address>

        <div className="pp-footer-bottom">
          <span>{t("footer.copyright", { year })}</span>
          <span>{t("footer.motto")}</span>
        </div>
      </div>
    </footer>
  );
};
